import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { Fuente } from '../model/Fuente';
import { Mother } from '../model/Mother';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_MotherFuente extends FuncionCompatilibidadBase<Mother, Fuente> {
  funciones = {
    socket: (mother: Mother, fuente: Fuente): Incompatibilities | null => {
      if (
        fuente.$caracteristicas._24pines == mother.$caracteristicas._24pines &&
        fuente.$caracteristicas._4pines + fuente.$caracteristicas._4plus >=
          mother.$caracteristicas._4pines + mother.$caracteristicas._4plus
      ) {
        return null;
      }
      return {
        tipo: IncompatibilitiesType.PRODUCTO,
        incompatibility: 'Mother y fuente son incompatibles',
      };
    },
  };
}
